import { ReactNode, useCallback } from 'react'

import { opBindings } from 'core-components/library/list/constants/filterLine'
import { BaseTemplate, IBaseTemplate } from 'core-components/library/multiSelect'
import { IDataProviderFilter, IFilter } from 'core-components/types'

export const FilterLineItemTemplate = (data: IBaseTemplate<IFilter | IDataProviderFilter>) => {
  const isIFilterOrIDataProviderFilter = (filter: IFilter | IDataProviderFilter) => {
    return 'field' in filter ? 'IFilter' : 'IDataProviderFilter'
  }

  const wrapToBaseTemplate = useCallback(
    (value: ReactNode, testId?: string) => {
      return <BaseTemplate {...data} customValueRender={value} __testId={testId} />
    },
    [data]
  )

  if (data.customValueRender) {
    return wrapToBaseTemplate(data.customValueRender)
  }

  const filterBuilder = (
    field: string,
    operator: string,
    value: string | number | string[] | null
  ) => {
    return `${field} ${opBindings[operator]} ${value}`
  }

  if (isIFilterOrIDataProviderFilter(data.item) === 'IDataProviderFilter') {
    const dataProviderFilter = data.item as IDataProviderFilter
    if (dataProviderFilter.filters) {
      const firstSimpleFilter = dataProviderFilter.filters.find(
        (it) => isIFilterOrIDataProviderFilter(it) === 'IFilter'
      ) as IFilter
      if (!firstSimpleFilter) {
        return null
      }
      const field = firstSimpleFilter.field
      const operator = firstSimpleFilter.operator
      let equalField = -1
      let equalOperator = -1
      dataProviderFilter.filters.forEach((el) => {
        if (isIFilterOrIDataProviderFilter(el) === 'IFilter') {
          const simpleFilter = el as IFilter
          if (simpleFilter.field === field) {
            equalField++
          }
          if (simpleFilter.operator === operator) {
            equalOperator++
          }
        }
      })
      if (equalField !== 0 && equalOperator !== 0) {
        const values: string[] = []
        dataProviderFilter.filters.forEach((el) => {
          if (isIFilterOrIDataProviderFilter(el) === 'IFilter') {
            const simpleFilter = el as IFilter
            if (simpleFilter.value) {
              values.push(simpleFilter.value.toString())
            }
          }
        })
        const filterString = filterBuilder(field, operator, values)
        return wrapToBaseTemplate(<span>{filterString}</span>, filterString)
      }
    }
    return <></>
  }
  const simpleFilter = data.item as IFilter
  const filterString = filterBuilder(simpleFilter.field, simpleFilter.operator, simpleFilter.value)
  return wrapToBaseTemplate(<span>{filterString}</span>, filterString)
}
